import { Injectable, ErrorHandler } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { AuthService } from './core/auth/auth.service';
import { AnalyticsService } from './utils/analytics/analytics.service';

import has from 'lodash/has';
import { environment } from 'src/environments/environment';
import { ToastController } from '@ionic/angular';
import { CoreService } from './core/core/core.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(
    public analytics: AnalyticsService,
    public core: CoreService,
    public auth: AuthService,
    public toastCtrl: ToastController,
  ) {}

  handleError(error): void {
    let errorMsg: string = 'Error';
    if (typeof error == 'object' || has(error, 'message')) {
      errorMsg = error.message;
    }

    if (this.analytics && this.auth) {
      this.analytics.trackEvent('Runtime Error', errorMsg, this.auth.Tracking_key, true);
    } else {
      if (datadogRum) {
        try {
          datadogRum.addUserAction('Runtime Error - No GA', {
            event_action: {
              action: 'Runtime Error occurred',
              label: error,
            },
          });
        } catch (e) {
          // ignore
        }
      }

      // log silently
      console.log(error);
    }

    if (this.core.DEV_MODE || (!environment.production && !environment.unit_test)) {
      this.toastCtrl
        .create({
          header: 'Runtime Error',
          message: errorMsg,
          duration: 10000,
        })
        .then(toast => {
          if (toast) {
            toast.present();
          }
        });

      throw error;
    }
  }
}
